import { render, staticRenderFns } from "./BuscarHistorico.vue?vue&type=template&id=254dabae&"
import script from "./BuscarHistorico.vue?vue&type=script&lang=js&"
export * from "./BuscarHistorico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports